var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteFriendGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "97px",
    height: "72px",
    viewBox: "0 0 97 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "invite-friend-green") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.166292793 0.584756098 26.1586351 0.584756098 26.1586351 26.5102805 0.166292793 26.5102805"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Invite-Friend",
    transform: "translate(-488.000000, -421.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invite-friend-green",
    transform: "translate(489.000000, 421.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(34.234234, 0.268902)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.162464,0.584670732 C5.9844009,0.584670732 0.166292793,6.38784146 0.166292793,13.5474756 C0.166292793,20.7062561 5.9844009,26.5102805 13.162464,26.5102805 C20.3396712,26.5102805 26.1586351,20.7062561 26.1586351,13.5474756 C26.1586351,6.38784146 20.3396712,0.584670732 13.162464,0.584670732 M13.162464,2.2919878 C19.384536,2.2919878 24.4469234,7.34137805 24.4469234,13.5474756 C24.4469234,19.7535732 19.384536,24.8029634 13.162464,24.8029634 C6.93953604,24.8029634 1.8780045,19.7535732 1.8780045,13.5474756 C1.8780045,7.34137805 6.93953604,2.2919878 13.162464,2.2919878",
    id: "Fill-1",
    fill: "#4D964C",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.9446081,9.90790244 C71.001545,9.90790244 66.1830766,14.714 66.1830766,20.6418049 C66.1830766,26.5704634 71.001545,31.3757073 76.9446081,31.3757073 C82.888527,31.3757073 87.7061396,26.5704634 87.7061396,20.6418049 C87.7061396,14.714 82.888527,9.90790244 76.9446081,9.90790244 M76.9446081,11.6152195 C81.9351036,11.6152195 85.9944279,15.6649756 85.9944279,20.6418049 C85.9944279,25.6194878 81.9351036,29.6683902 76.9446081,29.6683902 C71.9549685,29.6683902 67.8947883,25.6194878 67.8947883,20.6418049 C67.8947883,15.6649756 71.9549685,11.6152195 76.9446081,11.6152195",
    id: "Fill-4",
    fill: "#4D964C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.781518,9.90790244 C11.838455,9.90790244 7.01998649,14.714 7.01998649,20.6418049 C7.01998649,26.5704634 11.838455,31.3757073 17.781518,31.3757073 C23.7245811,31.3757073 28.5430495,26.5704634 28.5430495,20.6418049 C28.5430495,14.714 23.7245811,9.90790244 17.781518,9.90790244 M17.781518,11.6152195 C22.7720135,11.6152195 26.8313378,15.6649756 26.8313378,20.6418049 C26.8313378,25.6194878 22.7720135,29.6683902 17.781518,29.6683902 C12.7910225,29.6683902 8.7316982,25.6194878 8.7316982,20.6418049 C8.7316982,15.6649756 12.7910225,11.6152195 17.781518,11.6152195",
    id: "Fill-6",
    fill: "#4D964C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7012613,54.8891341 L28.0386937,54.8891341 C27.0895495,54.8891341 26.3201351,54.1225488 26.3201351,53.1758415 L26.3201351,40.524622 C26.3201351,34.7291341 31.0307658,30.0314512 36.8403153,30.0314512 L57.8181982,30.0314512 C63.5943694,30.0314512 68.2776126,34.7026707 68.2776126,40.4648659 L68.2776126,53.3081585 C68.2776126,54.1814512 67.5681081,54.8891341 66.6925676,54.8891341 L63.1176577,54.8891341",
    id: "Stroke-8",
    stroke: "#4D964C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9114685,54.3473171 C59.1784955,55.3571951 59.3214234,56.417439 59.3214234,57.510122 C59.3214234,64.3214634 53.7866036,69.8420732 46.9585856,69.8420732 C40.1305676,69.8420732 34.5948919,64.3214634 34.5948919,57.510122 C34.5948919,50.7004878 40.1305676,45.1790244 46.9585856,45.1790244 C49.4020541,45.1790244 51.6794865,45.8858537 53.5966036,47.1065854",
    id: "Stroke-10",
    stroke: "#4D964C",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-12",
    stroke: "#4D964C",
    strokeWidth: 2,
    points: "40.8256937 55.4719268 46.9587568 62.7536341 59.3215946 46.3446098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7924234,54.8891341 L92.7176036,54.8891341 C93.7566126,54.8891341 94.5987748,54.0491341 94.5987748,53.0136463 L94.5987748,42.4854756 C94.5987748,37.8057195 90.7953514,34.0129146 86.1044054,34.0129146 L70.8453514,34.0129146 C70.8453514,34.0129146 72.8891351,36.0523049 72.6948559,40.0329146 C72.4997207,44.0135244 72.7924234,54.8891341 72.7924234,54.8891341 Z",
    id: "Stroke-14",
    stroke: "#4D964C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8058378,54.8891341 L1.88065766,54.8891341 C0.841648649,54.8891341 -0.000513513514,54.0491341 -0.000513513514,53.0136463 L-0.000513513514,42.4854756 C-0.000513513514,37.8057195 3.80290991,34.0129146 8.49471171,34.0129146 L23.7529099,34.0129146 C23.7529099,34.0129146 21.7082703,36.0523049 21.9034054,40.0329146 C22.0976847,44.0135244 21.8058378,54.8891341 21.8058378,54.8891341 Z",
    id: "Stroke-16",
    stroke: "#4D964C",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteFriendGreen);
export default __webpack_public_path__ + "static/media/invite-friend-green.f27f3449b2d1b399a122918161a5b75b.svg";
export { ForwardRef as ReactComponent };